<template>
  <section>
    <HelloWorld msg="Welcome to Your Vue.js App"/>
    <div class="mainBgGray">
<!--      <ActivityList page="0" size="8" />-->
      <FullCalendar></FullCalendar>
      <NoticePopup/>
    </div>
  </section>
</template>

<script>
  // @ is an alias to /src
  import ActivityList from '@/components/activity/ActivityList.vue'
  import HelloWorld from '@/components/HelloWorld.vue'
  import FullCalendar from '@/components/FullCalendar.vue'
  import NoticePopup from '@/components/NoticePopup.vue'

  export default {
    name: 'home',
    components: {
      HelloWorld,
      FullCalendar,
      ActivityList,
      NoticePopup
    },
    mounted() {
      if (this.$auth.check() && this.$auth.user().isEmailAuthorized == 'false') {
        this.$router.push({name: 'authemail'})
      }
    }
  }
</script>
<style>
  @import '../assets/small-business.css';
</style>
